import { FormControl, TextField, Button, Grid, Autocomplete, useMediaQuery, Card, Dialog, DialogTitle, DialogActions, DialogContent, Divider, Box } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Colors } from '../../helpers/Colors.js';
import MonthPicker from '../custom/MonthPicker.jsx';
import { defaultProps, getCityFromid } from 'helpers/data';
import CityCardItem from 'components/city/CityCardItem';
import { calculateAvgValues, calculateMinCo2Mode } from 'helpers/Functions';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {  Typography } from '@mui/joy';
// @ts-ignore
import destinations from '../../data/data5.json';
import BackgroundImage from '../../media/trips.jpg';
import Loader from 'components/custom/Loader';

const Trips = () => {
    const { user, travelHistory, updateTravelHistory, removeTravelHistory, removeAccount } = useAuth();
    const [fromDestination, setFromDestination] = useState('');
    const [toDestination, setToDestination] = useState('');
    const [fromDestinationInputValue, setFromDestinationInputValue] = useState('');
    const [toDestinationInputValue, setToDestinationInputValue] = useState('');
    const [month, setMonth] = useState(new Date().toLocaleString('default', { month: 'long' }));
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Simulate a network request or loading time
        setTimeout(() => setLoading(false), 3000);
    }, []);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleRemoveAccount = async () => {
        await removeAccount();
    };

    const handleSaveTravelHistory = async (from, to) => {
        setLoading(true);
        await updateTravelHistory({
            from: from || "",
            to: to || "",
            month: month || "",
            mode: ""
        });

        setLoading(false);
    };

    const handleRemoveTravelHistory = async (from, to) => {
        setLoading(true); // Start loading spinner

        await removeTravelHistory({
            from: from || "",
            to: to || "",
            month: month || "",
            mode: ""
        });

        setLoading(false); // Stop loading spinner
    };

    const handleFromDestinationChange = (newValue) => {
        setFromDestination(newValue);
        console.log("HistoryfromDestination", fromDestination);
    };

    const handleToDestinationChange = (newValue) => {
        setToDestination(newValue);
    };

    const handleMonthChange = (newValue) => {
        setMonth(newValue);
    };

    const isInHistory = (from, to) => {

        const bool = travelHistory.some(
            (entry) => entry.from === from && entry.to === to
        )
        return bool
    }

    const handleItemClick = (from, to, val) => {

        if (!val) {
            handleSaveTravelHistory(from, to);
        } else {
            handleRemoveTravelHistory(from, to);
        }
        return isInHistory;
    };

    useEffect(() => {
        if (!user) {
            // If not logged in, redirect to the sign-in page
            navigate('/signin'); // Assuming your sign-in page is at /signin
        }
    }, [user, navigate]);

    const getFilteredOptions = (excludeCities) => {
        return destinations
            .filter(
                (destination) =>
                    !excludeCities.includes(destination.name)
            )
            .sort((a, b) => a.name.localeCompare(b.name));
    };

    return (
        <Box sx={{ m: 3 }}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                    height: "50vh",
                    overflow: "hidden",
                    margin: "10px auto",
                    backgroundImage: `url(${BackgroundImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                <Box sx={{
                    alignSelf: "flex-start",  // Align button container to the left side
                    margin: "20px 0 0 30px"   // Adjust margin as needed for spacing
                }}>
                </Box>
            </Box>
            <Divider />
            <Card>
                <Grid
                    container
                    spacing={2}
                    item
                    sx={{
                        minWidth: 0,
                        border: '2px solid',
                        borderShadow: 'md',
                        borderColor: Colors.gray,
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        display: "flex",
                        p: 2
                    }}
                >
                    <Grid item xs={12} sm={9} md={9} lg={9} xl={9}>
                        <Typography gutterBottom level='h4'>
                            Find all your saved trips here
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3} md={2} lg={2} xl={2}>
                        <Button variant="contained" onClick={handleClickOpen} size='small' sx={{
                            backgroundColor: Colors.green,
                            color: Colors.white,
                            '&:hover': {
                                backgroundColor: Colors.darkGreen,
                            },
                        }}>
                            Add new trip
                        </Button>
                    </Grid>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        fullWidth={true}
                        maxWidth={'md'}
                        PaperProps={{
                            component: 'form',
                        }}
                    >
                        <DialogTitle>Add a new trip</DialogTitle>
                        <DialogContent>
                            <Grid
                                container
                                spacing={2}
                                justifyContent='space-between'
                                alignItems='center'
                                item
                                sx={{
                                    padding: isSmallScreen ? 1 : 2,
                                    maxWidth: '100%',
                                }}
                            >
                                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                    <Autocomplete sx={{ width: '100%' }}
                                        {...defaultProps}
                                        options={getFilteredOptions([toDestination?.name])}
                                        id='from-destination'
                                        clearOnEscape
                                        onChange={(event, newValue) => {
                                            handleFromDestinationChange(newValue);
                                        }}
                                        inputValue={fromDestinationInputValue}
                                        onInputChange={(event, newInputValue) => {
                                            setFromDestinationInputValue(newInputValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label='From'
                                                required
                                                variant='outlined'
                                                fullWidth
                                                sx={{ backgroundColor: Colors.white, borderRadius: '4px' }}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                    <Autocomplete sx={{ width: '100%' }}
                                        {...defaultProps}
                                        options={getFilteredOptions([fromDestination?.name])}
                                        id='to-destination'
                                        clearOnEscape
                                        onChange={(event, newValue) => {
                                            handleToDestinationChange(newValue);
                                        }}
                                        inputValue={toDestinationInputValue}
                                        onInputChange={(event, newInputValue) => {
                                            setToDestinationInputValue(newInputValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label='To'
                                                required
                                                variant='outlined'
                                                fullWidth
                                                sx={{ backgroundColor: Colors.white, borderRadius: '4px' }}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                    <FormControl sx={{ width: '100%' }}>
                                        <MonthPicker handleMonthChange={handleMonthChange}></MonthPicker>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button sx={{
                                textColor: Colors.green,
                            }}
                                onClick={handleClose}>Cancel</Button>
                            <Button
                                variant='contained'
                                disabled={(fromDestination === null || toDestination === null) || (fromDestination === '' || toDestination === '')}
                                onClick={() => {
                                    const fromId = fromDestination?.id; const toId = toDestination?.id;
                                    const val = isInHistory(fromId, toId)
                                    if (!val) {
                                        handleSaveTravelHistory(fromId, toId);
                                    }
                                    handleClose();
                                }}
                                sx={{
                                    backgroundColor: Colors.green,
                                    textColor: Colors.black,
                                    '&:hover': {
                                        textColor: Colors.green,
                                    },
                                }}
                            >
                                Add
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Grid>
                {
                    loading ? (
                        <Loader />
                    ) : (
                        <Grid container spacing={2} sx={{ p: 3 }}>
                            {travelHistory?.map((history, index) => {
                                const from = getCityFromid(history?.from);
                                const to = getCityFromid(history?.to);
                                return (
                                    <Grid item xs={12} sm={6} md={6} lg={4} xl={4} key={history.to + history.from} sx={{ display: "flex", flexDirection: "column" }}>
                                        <Card sx={{ mb: 1 }}>
                                            <Typography level='title-md' sx={{ m: 1, "fontWeight": 'xs', "display": 'flex', "justifyContent": "space-around", "overflow": "hidden", "textOverflow": "ellipsis" }}>
                                                {from?.name} <ArrowForwardIcon /> {to?.name}
                                            </Typography>
                                            <Divider />
                                            <Typography level='title-md' sx={{ m: 1, "fontWeight": 'xs', "display": 'flex', "justifyContent": "space-around", "overflow": "hidden", "textOverflow": "ellipsis" }}>
                                                {history?.month}
                                            </Typography>
                                        </Card>
                                        <CityCardItem
                                            index={index}
                                            fromDestination={from}
                                            toDestination={to}
                                            month={month}
                                            minCo2Mode={calculateMinCo2Mode(from, to)}
                                            averages={calculateAvgValues(from, to, history.month)}
                                            sortBy={"overall"}
                                            clicked={isInHistory(history.from, history.to)}
                                            onItemClicked={() => handleItemClick(history.from, history.to, isInHistory(history.from, history.to))}
                                            interests={undefined} />
                                    </Grid>
                                );
                            })}
                        </Grid>
                    )}
                <Grid
                    container
                    spacing={2}
                    item
                    sx={{
                        minWidth: 0,
                        border: '2px solid',
                        borderShadow: 'md',
                        borderColor: Colors.gray,
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        display: "flex",
                        p: 2
                    }}
                >
                    <Grid item xs={12} sm={9} md={9} lg={9} xl={9}>
                        <Typography gutterBottom level='h4'>
                            Remove your account permanently
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3} md={2} lg={2} xl={2}>
                        <Button color='error' variant='contained' size='small' onClick={() => handleRemoveAccount()}>
                            Delete Account
                        </Button>
                    </Grid>
                </Grid>
            </Card>
        </Box>
    );
};

export default Trips;